import axios from 'axios'
import agencyPinAvailable from '../../../images/agency-pin-available.png'
import agencyPinUnavailable from '../../../images/agency-pin-unavailable.png'
import agencyPinSome from '../../../images/agency-pin-some.png'
import agencyPinAvailablePro from '../../../images/agency-pin-available-pro.png'
import agencyPinUnavailablePro from '../../../images/agency-pin-unavailable-pro.png'
import agencyPinSomePro from '../../../images/agency-pin-some-pro.png'
import updateBusinessSearchUrl from '../../utils/updateBusinessSearchUrl'

export default {
  namespaced: true,
  state: {
    selectedCity: undefined,
    businesses: [],
    resultsElement: undefined,
    mapMarkers: [],
    newMapDetector: false,
    businessAvailabilities: {},
    userCoords: undefined,
    businessDetail: undefined,
    proBusinesses: null,
  },
  mutations: {
    SET_SELECTED_CITY(state, city) {
      state.selectedCity = city
    },
    SET_BUSINESSES(state, businesses) {
      state.businesses = businesses
    },
    SET_RESULTS_ELEMENT(state, el) {
      state.resultsElement = el
    },
    ADD_MARKER(state, marker) {
      state.mapMarkers.push(marker)
    },
    CLEAR_MARKERS(state) {
      state.mapMarkers = []
    },
    ADD_AVAILABILITY(state, payload) {
      state.businessAvailabilities[payload.id] = payload.vehicles
    },
    SET_USER_COORDS(state, coords) {
      state.userCoords = coords
    },
    SET_BUSINESS_DETAIL(state, business) {
      state.businessDetail = business
    },
    SET_PRO_BUSINESSES(state, proBusinesses) {
      state.proBusinesses = proBusinesses
    },

  },
  actions: {
    async GET_BUSINESSES_FOR_CITY({ commit, rootState, dispatch }, payload) {
      const { city } = payload;
      const { overrideLoader } = payload;

      if (!overrideLoader) {
        dispatch('ui/SET_PAGELOAD_TRUE', undefined, { root: true });
      }
      const res = await axios.post(`${rootState.api}/businesses/search`, {
        city_proxy: city.id,
        zipcode: city.postal_code,
        latitude: city.latitude,
        longitude: city.longitude,
      })

      updateBusinessSearchUrl(city.label)

      dispatch('ui/SET_PAGELOAD_FALSE', undefined, { root: true });

      const businesses = res && res.data && res.data.data

      commit('SET_SELECTED_CITY', city)

      if (businesses) {
        commit('SET_BUSINESSES', businesses)
      }
    },
    async GET_BUSINESSES_FROM_LOCATION({ commit, rootState, dispatch }, coords) {
      commit('SET_USER_COORDS', coords)
      dispatch('ui/SET_PAGELOAD_TRUE', undefined, { root: true });
      const res = await axios.post(`${rootState.api}/businesses/search`, coords)
      dispatch('ui/SET_PAGELOAD_FALSE', undefined, { root: true });

      const businesses = res && res.data && res.data.data

      commit('SET_SELECTED_CITY', businesses[0].city)

      if (businesses) {
        commit('SET_BUSINESSES', businesses)
      }
    },
    UPDATE_MAP_MARKER_ICONS({ state, dispatch }) {
      state.mapMarkers.forEach((marker) => {
        if (!(marker.rentBusinessId in state.businessAvailabilities)) {
          return
        }
        dispatch('UPDATE_MARKER_ICON', marker)
      })
    },
    UPDATE_MARKER_ICON({ state }, marker) {
      const availabilities = state.businessAvailabilities;
      const id = marker.rentBusinessId;
      if (availabilities[id] === 0) {
        marker.setIcon(marker.rentPro ? agencyPinUnavailablePro : agencyPinUnavailable)
      }

      if (availabilities[id] === 1) {
        marker.setIcon(marker.rentPro ? agencyPinSomePro : agencyPinSome)
      }

      if (availabilities[id] > 1) {
        marker.setIcon(marker.rentPro ? agencyPinAvailablePro : agencyPinAvailable)
      }
    },
    GET_BUSINESS_DETAIL({ commit, rootState }, id) {
      axios(`${rootState.api}/businesses/${id}`)
        .then((res) => commit('SET_BUSINESS_DETAIL', res.data.data))
    },
    GET_PRO_BUSINESSES({ commit, rootState }) {
      axios(`${rootState.api}/businesses?filter[is_pro_plus]=1`)
        .then((res) => commit('SET_PRO_BUSINESSES', res.data.data))
    },
  },
}
